


















import {
  computed,
  defineComponent, onMounted, Ref, ref,
} from '@vue/composition-api';
import { format } from 'date-fns';
import { pl } from 'date-fns/locale';

const Clock: object = defineComponent({
  name: 'Clock',
  setup() {
    const currentTime: Ref<Date> = ref(new Date());

    const formatedTime: Ref<string> = computed(() => format(currentTime.value, 'HH:mm', { locale: pl }));

    const formatedDay: Ref<string> = computed(() => format(currentTime.value, 'd MMMM', { locale: pl }).toLowerCase());

    const formatedWeekday: Ref<string> = computed(() => format(currentTime.value, 'EEEE', { locale: pl }).toLowerCase());

    onMounted(() => {
      currentTime.value = new Date();
      const offset = 1000 - currentTime.value.getMilliseconds();
      setTimeout(() => {
        setInterval(() => {
          currentTime.value = new Date();
        }, 1000);
      }, offset);
    });

    return {
      currentTime,
      formatedTime,
      formatedDay,
      formatedWeekday,
    };
  },
});
export default Clock;
